<ion-content>
  <div class="flex-container-col">
    <div class="card-header">
      <div>
        <span class="icon-search search-icon" aria-hidden="true"></span>
        <input
          class="search-box-input"
          (keyup)="onKeyUpHandler($event)"
          [(ngModel)]="searchInput"
          [placeholder]="'search-menu.search-box.placeholder' | translate"/>
      </div>
      <div class="close-btn-container">
        @if ((!!searchTerm || searchResults?.length > 0) && !(isLoadingSearchResults$ | async)) {
          <ion-button
            fill="clear"
            mode="ios"
            class="btn btn-clear"
            (click)="clearSearch()">
            {{'search-menu.clear-button' | translate}}
          </ion-button>
        }
        <ion-button
          fill="clear"
          mode="ios"
          class="btn btn-menu-header-close"
          [title]="'global.menu.close-menu' | translate"
          (click)="closeSearchMenu()">
          <span class="icon-exit" aria-hidden="true"></span>
        </ion-button>
      </div>
    </div>

    <div class="search-results-container">
      @if (showRecentSearches) {
        @if (!(isLoadingRecentSearches$ | async)) {
          <ion-list class="list recent-searches" lines="none">
            <ion-item class="list-item">
              <ion-label class="recent-searches-time">
                {{'search-menu.recentSearch-today' | translate}}
              </ion-label>
            </ion-item>
            @for (recentSearch of recentSearches?.today; track trackByRecentSearchRecordId($index, recentSearch)) {
              <ion-item
                class="list-item"
                (click)="onClickRecentSearch(recentSearch)">
                <ion-label class="recent-searches-data">{{ recentSearch.searchTerm }}</ion-label>
              </ion-item>
            }
          </ion-list>
          @if (recentSearches?.today.length < 25) {
            <ion-list class="list recent-searches" lines="none">
              <ion-item class="list-item">
                <ion-label class="recent-searches-time">
                  {{'search-menu.recentSearch-this-week' | translate}}
                </ion-label>
              </ion-item>
              @for (recentSearch of recentSearches?.thisWeek; track trackByRecentSearchRecordId($index, recentSearch)) {
                <ion-item
                  class="list-item "
                  (click)="onClickRecentSearch(recentSearch)">
                  <ion-label class="recent-searches-data">{{ recentSearch.searchTerm }}</ion-label>
                </ion-item>
              }
            </ion-list>
          }
        } @else {
          @for (item of [0, 1, 3]; track item) {
            <ion-item class="list-item__title list-item__title--ellipsis">
              <ion-skeleton-text animated style="width: 100%;"></ion-skeleton-text>
            </ion-item>
          }
        }
      }
      @if (searchResults?.length === 0 && searchTerm && !showRecentSearches && !(isLoadingSearchResults$ | async)) {
        <div
          class="zero-state-container"
          >
          <span
            class="zero-state-label"
            [innerHTML]="('search-menu.no-search-result-text' | translate) + searchTerm + ('search-menu.no-search-result-suggestion-text' | translate) ">
          </span>
        </div>
      } @else {
        @if (!!searchResults) {
          <div
            class="card-content display-results">
            <ion-list class="list list-search-results">
              @for (searchResult of searchResults; track trackBySearchResultRecordId($index, searchResult)) {
                <ion-item
                  class="list-item search-item-list"
                  tabindex="0"
                  ngClass="list-item--{{ searchResult.category }}-item"
                  lines="full"
                  (click)="navigateToSearchResult(searchResult)">
                  <span
                    class="list-item__icon label-icon"
                    ngClass="{{ searchResult.category === assessmentType ? (searchResult.object.type | observationIcon) : (searchResult.category | searchResultIcon) }}"
                    aria-hidden="true"
                    slot="start"
                  ></span>
                  <ion-label>
                    <h3 class="list-item__title list-item__title--ellipsis"
                      ngClass="list-item--{{ searchResult.category }}-text">
                      {{ searchResult.title }}
                    </h3>
                    @if (searchResult.category === 'assessment') {
                      <h4 class="list-item__subtitle"
                        >
                        {{ searchResult.object.path }}
                      </h4>
                    }
                  </ion-label>
                </ion-item>
              }
            </ion-list>
          </div>
        }
        @if (isLoadingSearchResults$ | async) {
          <ion-spinner class="search-results-loader"></ion-spinner>
        }
      }
    </div>
  </div>
</ion-content>
